import React, { Component } from "react";
import { connect } from 'react-redux';
import { fetchAttendance } from "../actions/api"

class Attendance extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

    }

    componentDidMount() {
        if (!this.state.attendanceRequested) {
            this.setState({ attendanceRequested: true },
                this.props.fetchAttendance());
        }
    }

    formatDate(x) {
        function pad(params) {
            return params.toString().padStart(2, '0');
        }
        return `${pad(x.getDate())}/${pad(x.getMonth() + 1)}/${pad(x.getFullYear())}`;
    }

    render() {
        const attendance = this.props.attendance;
        if (attendance) {
            var cache = {};
            attendance.forEach(row => {
                if (row['employee_id']) {
                    cache[row['employee_id']] = cache[row['employee_id']] || { 'employeeName': row['full_name'], history: {} };
                    cache[row['employee_id']]['history'][row['date']] = row['time'];
                }
            });
            console.log(cache);
            var start = new Date();
            start.setDate(1);
            var end = new Date(start);
            var dateArray = [];
            var comp;
            end.setMonth(end.getMonth() + 1);
            for (start; start < end; start.setDate(start.getDate() + 1)) {
                dateArray.push(this.formatDate(start));
            }
            comp = (
                <table className="view">
                    <thead><tr>
                        <td></td>
                        {dateArray.map(d => <td>{d.split('/')[0]}</td>)}
                    </tr></thead>
                    <tbody>

                        {
                            Object.keys(cache).map(key => {
                                return (
                                    <tr>
                                        <td className="row-head">{cache[key].employeeName}</td>
                                        {dateArray.map(d => {
                                            return <td id={`${key}-${d}`} title={cache[key]['history'][d]} className={cache[key]['history'][d] ? 'on' : 'off'} />
                                        })}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            )
        }
        const component = (
            <div className="container-fluid">
                {comp}
            </div>

        );
        return component;
    }
}

const mapStateToProps = ({ reducer: store }) => ({
    attendance: store.attendance,
});
export default connect(mapStateToProps, { fetchAttendance }, null, { areStatesEqual: (next, prev) => !next.reducer.attendance || next.reducer.attendance === prev.reducer.attendance })(Attendance);
